var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';
import { oneOf, node, bool } from 'prop-types';
import { margins } from '@gympass/yoga-system';
var StyledTag = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n\n  border-style: solid;\n\n  ", "\n\n  ", "\n"])), function (_ref) {
  var variant = _ref.variant,
      small = _ref.small,
      _ref$theme$yoga = _ref.theme.yoga,
      _ref$theme$yoga$color = _ref$theme$yoga.colors,
      text = _ref$theme$yoga$color.text,
      elements = _ref$theme$yoga$color.elements,
      _ref$theme$yoga$color2 = _ref$theme$yoga$color.feedback,
      _ref$theme$yoga$color3 = _ref$theme$yoga$color2[variant],
      color = _ref$theme$yoga$color3 === void 0 ? {
    dark: text.secondary
  } : _ref$theme$yoga$color3,
      _ref$theme$yoga$color4 = _ref$theme$yoga$color2[variant],
      borderColor = _ref$theme$yoga$color4 === void 0 ? {
    dark: elements.selectionAndIcons
  } : _ref$theme$yoga$color4,
      tag = _ref$theme$yoga.components.tag;
  return "\n    " + (small ? "\n            padding:\n              " + tag.padding.small.top + "\n              " + tag.padding.small.right + "px\n              " + tag.padding.small.bottom + "\n              " + tag.padding.small.left + "px;\n          " : "\n            padding:\n              " + tag.padding["default"].top + "px\n              " + tag.padding["default"].right + "px\n              " + tag.padding["default"].bottom + "px\n              " + tag.padding["default"].left + "px;\n          ") + "\n   \n    color: " + color.dark + ";\n    border-radius: " + tag.border.radius + "px;\n    border-width: " + tag.border.width + "px;\n    border-color: " + borderColor.dark + ";\n\n    font-size: " + tag.font.size + "px;\n    line-height: " + tag.font.lineHeight + "px;\n    font-weight: " + tag.font.weight + ";\n  ";
}, margins);
/** Tags should be keywords to categorize or organize an item. */

var Tag = function Tag(props) {
  return /*#__PURE__*/React.createElement(StyledTag, props);
};

Tag.propTypes = {
  /** style the tag following the theme (success, informative, attention) */
  variant: oneOf(['', 'success', 'informative', 'attention']),
  children: node.isRequired,

  /** Can send small to use this variant */
  small: bool
};
Tag.defaultProps = {
  variant: '',
  small: false
};
export default Tag;